"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var BitcoinTransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(BitcoinTransactionRequest, _super);
    function BitcoinTransactionRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BitcoinTransactionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.BitcoinTransactionRequest = BitcoinTransactionRequest;
//# sourceMappingURL=BitcoinTransactionRequest.js.map